import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { PageChangeEvent } from '@progress/kendo-angular-pager';
import { BehaviorSubject, combineLatest, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { IGallery } from '../core/data/gallery';
import { GalleryService } from '../core/data/gallery.service';
import { SettingsService } from '../core/data/settings.service';

const gallery: IGallery = {
    state: {
        skip: 0,
        take: 12
    },
    sortBy: 'Most Funded to Least Funded',
    sortOptions: [
        'Most Funded to Least Funded',
        'Least Funded to Most Funded',
        'Newest to Oldest',
        'Oldest to Newest',
    ]
} as IGallery;

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ss-gallery-component',
    templateUrl: './gallery.component.html',
    styleUrls: ['./gallery.component.css']
})

export class GalleryComponent {
    private galleryCompState$ = new BehaviorSubject(gallery);
    selectedValue = gallery.sortOptions[0];

    vm$ = this.galleryCompState$
        .pipe(
            switchMap((galleryComp) => combineLatest([
                this.galleryService.getGallery(galleryComp),
                of(galleryComp),
                this.settingsService.galleryHeaderImageURI$,
                this.settingsService.schoolLogoImageURI$,
                this.galleryService.getGalleryInfo$,
            ])),
            map(([clientGallery, compState, headerImageURI, schoolLogoImageURI, galleryInfo]) => (
                {
                    gallery: clientGallery.galleryItems,
                    state: compState.state,
                    total: clientGallery.total,
                    sortOptions: compState.sortOptions,
                    galleryHeadline: galleryInfo.GalleryHeadline,
                    galleryParagraphText: galleryInfo.GalleryParagraphText,
                    gallerySchoolName: galleryInfo.SchoolName,
                    headerImageURI,
                    hasSchoolLogoImage: schoolLogoImageURI !== '',
                    schoolLogoImageURI
                }))
        );

    constructor(
        private galleryService: GalleryService,
        private settingsService: SettingsService,
        private router: Router) { }

    
    onStateChange = (currentState: PageChangeEvent) =>
        this.galleryCompState$.next({
            ... this.galleryCompState$.getValue(),
            state: currentState,
            sortBy: this.selectedValue
        })

    goToCampaign = (campaignId: number) => window.open(this.router.createUrlTree(['/campaign', campaignId]).toString(), '_blank');
}
